import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  setOpenExternalLinkInSameTab,
  setGoHome,
} from "../../action/homeAction";
import FooterNavigation from '../footerNaviagtion/footerNavigation';
import { ALLOW_ONLY_WHITELISTED_URLS_FOR_IFRAME_RENDERER, CMSPath, commanEventListerKey, WHITELISTED_URLS_FOR_IFRAME_RENDERER } from '../../../config/constant';
import MiniLoader from '../../UI/MiniLoader';
import { currentWidget, setFailScreen } from '../../../action/action';
import { inAppBrowser } from '../../JS/inAppBrowser';
import { sendAnalytics } from '../../../action/homeAction';
import { scrollToTop } from '../../../JS/scrollToTop';
class IframRenderWidget extends Component {
  constructor(props) {
    super(props);
    this.state = {
      widgetData: {},
      initialLoading: true,
      attachEventHandlerTimer: null
    };
    // Bind method to instance
    this.handleIframeMessage = this.handleIframeMessage.bind(this);
    this.handleIframeLoad = this.handleIframeLoad.bind(this)
  }

  iframeTimeout = null;

  handleIframeMessage(event) {
    try {
      const message = event;
      console.log(message);

      if (message && message.data.type === "INNSPIRE_GO_HOME") {
        this.props.setGoHome(true)
        return;
      }

      if(message.data && message.data.type == "INNSPIRE_SAVE_DATA"){

        const toBeStoredDataKey = message.data.payload.key;
        const toBeStoredData = message.data.payload.value;

        localStorage.setItem(toBeStoredDataKey, toBeStoredData)
        return;
      }


      if (message.data && message.data.type === "INNSPIRE_GET_DATA") {
          const dataKeys = message.data.payload.key || [];
          const responseData = {};
      
          dataKeys.forEach((key) => {
              const storedData = localStorage.getItem(key);
              if(storedData) responseData[key] = storedData;
          });
          const iframes = document.getElementsByTagName('iframe');

          Array.from(iframes).forEach((iframe) => {
              if (iframe.src && iframe.src.includes(message.origin)) {
                  iframe.contentWindow.postMessage({
                      type: "INNSPIRE_DATA_TO_IFRAME",
                      payload: responseData
                  }, "*");
              }
          });

          return;
      }

      if(message.data && message.data.type == "INNSPIRE_OPEN_URL"){

        const targetUrl = message.data.payload && message.data.payload.url;
        const target = message.data.payload.target;

        inAppBrowser(targetUrl, this.props, false, {
            widgetType: "Url Renderer",
            meta: {
                loadInExternalBrowser: target === "_system",
                dontSetCurrentWidget: true
            }
        });
    }


    } catch (error) {
      console.error("Error handling iframe message:", error);
    }
  }

  componentDidMount() {
    this.iframeTimeout = setTimeout(() => {
      if (this.state.initialLoading && !navigator.onLine) {
        this.setState({initialLoading: false });
        this.props.setFailScreen(true, "Failed to get the data", "We are not not able to get the data, please check your internet connection or try again", true)
        this.props.setGoHome(true);
      }
    }, 10000);

    scrollToTop();
    const { currentWidget } = this.props;
    if (currentWidget) {
      this.setState({ widgetData: currentWidget });
    }

    // Add message listener
    this.attachEventHandlerTimer = setTimeout(() => {
      if (!window[commanEventListerKey]) {
        window.addEventListener("message", this.handleIframeMessage);
        window[commanEventListerKey] = true;
      }
      this.setState({ attachEventHandlerTimer : null});
    }, 0);

    if (!window.cordova || !window.cordova.platformId) return;

    const platform = window.cordova.platformId;
  
    if (platform === 'android') {
      console.log("Initializing plugin (Android)");
      window.cordova.exec(
        () => console.log("Navigation plugin initialized (Android)"),
        (err) => console.error("Navigation plugin init error (Android):", err),
        "CustomNavigationPlugin",
        "initializePlugin",
        []
      );
    } else if (
      platform === 'ios' &&
      window.cordova.plugins &&
      window.cordova.plugins.customNavigation
    ) {
      console.log("Initializing plugin (iOS)");
      window.cordova.plugins.customNavigation.initializePlugin(
        () => console.log("Navigation plugin initialized (iOS)"),
        (err) => console.error("Navigation plugin init error (iOS):", err)
      );
    }
  }

  componentDidUpdate(prevProps) {
    const { currentWidget } = this.props;

    if (prevProps.currentWidget !== currentWidget && currentWidget && Object.keys(currentWidget).length > 0) {
      this.setState({ widgetData: currentWidget });
    }
  }

  componentWillUnmount() {
    clearTimeout(this.iframeTimeout);

    this.props.setCurrentWidget({});
    
    window.removeEventListener("message", this.handleIframeMessage);
    if (window[commanEventListerKey]) {
      window[commanEventListerKey] = false;
    }
    if(this.attachEventHandlerTimer) clearTimeout(this.attachEventHandlerTimer);

    if (!window.cordova || !window.cordova.platformId) return;

    const platform = window.cordova.platformId;
  
    if (platform === 'android') {
      console.log("Removing plugin (Android)");
      window.cordova.exec(
        () => console.log("Navigation plugin removed (Android)"),
        (err) => console.error("Navigation plugin remove error (Android):", err),
        "CustomNavigationPlugin",
        "removePlugin",
        []
      );
    } else if (
      platform === 'ios' &&
      window.cordova.plugins &&
      window.cordova.plugins.customNavigation
    ) {
      console.log("Removing plugin (iOS)");
      window.cordova.plugins.customNavigation.removePlugin(
        () => console.log("Navigation plugin removed (iOS)"),
        (err) => console.error("Navigation plugin remove error (iOS):", err)
      );
    }
  }

  handleIframeLoad = () => {
    clearTimeout(this.iframeTimeout);
    this.setState({ initialLoading: false });
  };


  render() {
    const { widgetData } = this.state;
    const { guestDetail } = this.props;

    let targetUrl = null;
  if (widgetData.targetUrl) {
    targetUrl = widgetData.targetUrl;
  }

  let resolvedUrl = null;
  if (targetUrl) {
    resolvedUrl = targetUrl.startsWith("http")
      ? targetUrl.replace("#RESERVATION_ID", guestDetail.reservationNumber || "")
      : CMSPath + targetUrl.replace("#RESERVATION_ID", guestDetail.reservationNumber || "");
  }

  if(ALLOW_ONLY_WHITELISTED_URLS_FOR_IFRAME_RENDERER && resolvedUrl){
    const isTargetUrlAmongWhitelisted = WHITELISTED_URLS_FOR_IFRAME_RENDERER.some((url)=>{return resolvedUrl.includes(url)});

    if(!isTargetUrlAmongWhitelisted){
        if(window.cordova || window.device) inAppBrowser(resolvedUrl , this.props, true, { displayName: "", dontSetCurrentWidget: true })
        else window.open(resolvedUrl);

        this.props.setGoHome(true);
        return (<></>);
    }
  }

    return (
      (
        <>
          <header className="inner-pages w-footer subpages iframe-header">
            <a
              onClick={() => this.props.setGoHome(true)}
              className="button-back"
            ></a>
            <div className="heading align-center">
              <div className="splash-brand">
                <img src={`${CMSPath}${this.props.logo}`} alt="Logo" />
              </div>
            </div>
          </header>

          <section
            className={`widgets external_url_iframe padding-0 margin-0 container-bg ${widgetData.widgetMetaHtmlId || ""} `}
            style={widgetData.compImage ? { backgroundImage: `url('${widgetData.compImage}')` }: {}}
          >
            {this.state.initialLoading && <MiniLoader />}
            <iframe
              src={resolvedUrl}
              onLoad={this.handleIframeLoad}
              allow="geolocation"
              sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-modals allow-presentation allow-downloads allow-popups-to-escape-sandbox"
              style={{ display: this.state.initialLoading ? "none" : "block" }}
            ></iframe>
          </section>

          <FooterNavigation />
        </>
      )
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentWidget: state.store.sideNavBar.currentWidget,
    menuColor: state.store.home.MenuColor,
    installedAppVersion: state.store.installedAppVersion,
    installedAppBuildNo: state.store.installedAppBuildNo,
    guestIsLoggedIn: state.store2.guestIsLoggedIn,
    guestDetail: state.store.home.guestDetails,
    logo: state.store.home.currentDuration.brandingInfo ?
      state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
  };
};

const mapDispatchToProps = {
  setGoHome,
  sendAnalytics,
  setOpenExternalLinkInSameTab,
  setCurrentWidget: currentWidget,
  setFailScreen
};

export default connect(mapStateToProps, mapDispatchToProps)(IframRenderWidget);




// KNOWN ISSUE
// While Rendering content in iframe, content does not show up instantly. When user scroll a bit then content become visible. Usually happen in only IOS
// Solution is to force Iframe webview to bit shake, for this changing width and height a bit once content is loaded. CSS for this is 


// section#app-body section.widgets.external_url_iframe iframe {
//   width: 100%;
//   height: 100%;
//   display: block;
//   animation: fixRendering 2s ease-in-out forwards;
//   border: none;  /* Ensure no border issues */
// }

// @keyframes fixRendering {
//   0% { height: 95%; width: 95%; }
   
//   10% { height: 98%; width: 98%; }
//   20% { height: 96%; width: 99%; }
//   40% { height: 99%; width:98.6% }
//   50% { height: 99.5%; width: 98.5%; }
//   60% { height: 100%; width: 100%; }
  
//   70% { height: 97.5%;}

//   100% { height: 99%; width:99%  }
// }


